import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import {startSession, updateToken, logout} from './auth/services/SessionService'
import storeConstants from './utils/constants/StoreConstants'

import './registerServiceWorker';
import './auth/interceptors/registerAuthInterceptor';

Vue.config.productionTip = false;

function animateLogoSplashScreen():Promise<void> {
  return new Promise((resolve, reject) => {
    const REMOVE_ANIMATE_CLASS_TIME = 333
    const SHOW_APP_TIME = 333

    document.getElementById('c2b-logo-splash')?.classList.add('animate')

    setTimeout(() => {
      document.getElementById('c2b-logo-splash')?.classList.remove('animate')

      setTimeout(() => {
        resolve()
      }, SHOW_APP_TIME)
    }, REMOVE_ANIMATE_CLASS_TIME)    
  })
}

;(async () => {
  const MAX_SESSION_TIME = 2 * 60 * 60 * 1000; // 2h
  const UPDATE_SESSION_TIME = 30 * 60 * 1000; // 30min

  try {
    await startSession()
    await updateToken(MAX_SESSION_TIME)
    await store.dispatch(storeConstants.actions.GET_AUTHENTICATED_USER)
    await animateLogoSplashScreen()

    new Vue({
      router,
      store,
      render: (h) => h(App),      
    }).$mount('#app')

    setInterval(async () => {
      await updateToken(UPDATE_SESSION_TIME)
    }, UPDATE_SESSION_TIME)

    window.onfocus = () => {
      updateToken(UPDATE_SESSION_TIME) 
    }
  } catch(err) {
    if (err.status === 401 || err.status === 403) {
      let msg = `${err.message}`

      if (!!err.errorCode) {
        msg += `\n\nCódigo do erro: ${err.errorCode}`
      }

      alert(msg)
      return await logout()
    }
  }
})();
